<template>
  <section class="exchangePanel">
    <div>
      <header>
        <div>
          <p><b>{{ disponiveis.length }} itens disponíveis</b></p>
          <a href="#" class="btn btn-secondary btn-small" @click.prevent="addAll()">Selecionar Tudo</a>
        </div>
        <div class="search-box">
          <fa :icon="['far','magnifying-glass']" class="ic" />
          <input type="text" placeholder="O que você procura?" />
        </div>
      </header>
      <div>
        <ul>
          <li
            v-for="(item, i) in disponiveis"
            :key="item.idNegocieJaFormaPagamento"
            @click.prevent="addToSelected(i)"
          >
            <span>{{ item.nome }}</span>
            <fa :icon="['fal','arrow-right-long']" class="ic" />
          </li>
        </ul>
      </div>
    </div>
    <div>
      <header>
        <div>
          <p><b>{{ selecionados.length }} itens selecionados</b></p>
          <a href="#" class="btn btn-secondary btn-small" @click.prevent="removeAll()">Remover Tudo</a>
        </div>
        <div class="search-box">
          <fa :icon="['far','magnifying-glass']" class="ic" />
          <input type="text" placeholder="O que você procura?" />
        </div>
      </header>
      <div>
        <ul>
          <li
            v-for="(item, i) in selecionados"
            :key="item.idNegocieJaFormaPagamento"
            @click.prevent="removeFromSelected(i)"
          >
            <span>{{ item.nome }}</span>
            <fa :icon="['fal','arrow-left-long']" class="ic" />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import NegociaService from '@/services/negocieja.service.js'

export default {
  props: {
    formasPagamento: {
      type: Array
    }
  },
  data () {
    return {
      disponiveis: [],
      selecionados: []
    }
  },
  watch: {
    formasPagamento ( value ) {
      if ( value ) {
        this.getPagamentos()
      }
    }
  },
  mounted () {
    this.getPagamentos()
  },
  methods: {
    getPagamentos () {
      NegociaService.getPagamentos().then( 
        response => {
          const pagamentos = Object.assign([], response.data)
          
          this.selecionados = pagamentos.filter( a => this.formasPagamento.includes(a.idNegocieJaFormaPagamento))
          this.disponiveis = pagamentos.filter( a => !this.formasPagamento.includes(a.idNegocieJaFormaPagamento))

          this.emitList()
        },
        error => {
          console.error('Erro ao buscar formas de pagamento:', error)
        }
      )
    },
    addToSelected ( i, scape ) {
      const item = this.disponiveis[i]

      this.selecionados.push(item)

      if ( !scape ) {
        this.disponiveis.splice(i,1)
      }

      this.emitList()
           
    },
    removeFromSelected ( i, scape ) {
      const item = this.selecionados[i]
      const originalIndex = item.originalIndex

      if ( originalIndex || originalIndex == 0 ) {
        delete item.originalIndex

        this.disponiveis.splice(originalIndex, 0, item)
      } else {
         this.disponiveis.push(item)
      }
      
      if ( !scape ) {
        this.selecionados.splice(i,1)
      }

      this.emitList()
    },
    addAll () {
      this.selecionados.push(...this.disponiveis)
      this.disponiveis = []
      this.emitList()
    },
    removeAll () {
      this.disponiveis.push(...this.selecionados)
      this.selecionados = []
      this.emitList()
    },
    emitList () {
      this.$emit("onChange", this.selecionados)
    }
  }
}
</script>

<style lang="scss" scoped>
  .exchangePanel {
    > div {
      height: 100%;
      display: flex; flex-direction: column;

    header {
      width: 100%;

      > div {
        position: relative;

        p {
          padding: 0;
          margin: 0;
        }

        &:first-child {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: $mg_mini $hmg_small;
        }

        &.search-box {
          background-color: $color-bg;
          border-top: $border-component;
          border-bottom: $border-component;
          height: 40px;

          input {
            background: transparent;
            padding: 0 $hmg_small;
            width: 100%;
            height: 100%;
            border: 0;
            box-shadow: none;
            font-size: $font-size-small;

            &::placeholder {
              color: $color-mid-grey;
            }

            &:focus {
              outline: none;
              box-shadow: none;
              border: 0;
            }
          }

          .ic {
            position: absolute;
            right: $hmg_small;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }

    > div {
      flex: 1;
      overflow: auto;
      @extend %scrollbar_light_panel;

      ul {
        padding: 0;
        margin: 0;

        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: $mg_mini $hmg_small;
          list-style: none;
          border-bottom: $border-component;
          cursor: default;

          .ic {
            @extend %transition_3e;
          }

          &:hover {
            .ic {
              color: $color-primary;
            }
          }
        }
      }
    }
  }
}
</style>